import { render, staticRenderFns } from "./profit_and_loss_temp1.vue?vue&type=template&id=36d09212&"
import script from "./profit_and_loss_temp1.vue?vue&type=script&lang=js&"
export * from "./profit_and_loss_temp1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports